import React,{ useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Container, Row, Col, Image ,Button } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { Navigation } from 'swiper/modules';
import { Time, Calendar ,BtnArrow , StarIcon} from "../../svgIcon";
// import "./_event-listing.scss";
import "../newsSection/_news-details-page.scss";
import CommonCrypt from "../../Common/CommonCrypt";
import { Helmet } from 'react-helmet-async';
function EventCalenderDetail({PageData,DetailRecord,ContactInfo,alias,Constant}){
    const APP_URL = window.site_url;
    const CDN_URL = window.cdn_path;

    let ImageWebp = '';
    if(DetailRecord?.varWebpImgURL){
        ImageWebp = CDN_URL+'caches/'+Constant?.EVENTCALENDERTHUMB?.split(',')[1]?.replace('*','x')+'/'+DetailRecord?.varWebpImgURL;
    }else{
        ImageWebp = CDN_URL+'assets/images/'+DetailRecord?.varImgURL;
    }

    const [OtherEvents,setOtherEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(()=>{
        const fetchEventData = async () =>{
            const response = await fetch(APP_URL + '/api/event-calendar?ignoreid='+DetailRecord?.id,{
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                },
            });
            const eventsData = await response.json();
            const eventsDataDecrypted = JSON.parse(CommonCrypt(eventsData.events_result));

            setOtherEvents(eventsDataDecrypted);
            setIsLoading(false);
        }
        fetchEventData();
    },[]);

    const formatDate = (date) => {
        return new Date(date).toLocaleString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',            
        });
    };

    const formatTime = (date) => {
        return new Date(date).toLocaleString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        });
    };

    const formatDateTime = (date) => {
        return new Date(date).toLocaleString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',   
            hour: 'numeric',
            minute: '2-digit',
            hour12: true         
        });
    };

    return (
        <>
            <section className="section-gap double-gap news-details" data-aos="fade">
                <Container className="container">
                    <Row className="row justify-content-center">
                        <Col lg={12} className="text-center">
                            {/* <h4>{DetailRecord?.varTitle}</h4> */}
                            <h4 className="mb-3 title">{DetailRecord?.varTitle}</h4>
                            <ul className="list-unstyled mb-4 mb-lg-5 d-flex justify-content-center date-time flex-wrap">                                
                                <li className="d-flex align-items-center"><span className="me-2"><i><Calendar/></i></span> {formatDateTime(DetailRecord?.dtDateTime)} {DetailRecord?.dtEndDateTime ? ' to ' + formatDateTime(DetailRecord?.dtEndDateTime) : ''}
                                </li>
                                {/* <li className="d-flex align-items-center"><span className="me-2"><i><Calendar/></i></span>
                                    {formatDate(DetailRecord?.dtDateTime) == formatDate(DetailRecord?.dtEndDateTime) ? formatDate(DetailRecord?.dtDateTime) : formatDate(DetailRecord?.dtDateTime) +' to ' + formatDate(DetailRecord?.dtEndDateTime)}.
                                </li>
                                <li className="d-flex align-items-center"><span className="me-2"><i><Time/></i></span>
                                    {formatTime(DetailRecord?.dtDateTime) == formatTime(DetailRecord?.dtEndDateTime) ? formatTime(DetailRecord?.dtDateTime) : formatTime(DetailRecord?.dtDateTime) +' - ' + formatTime(DetailRecord?.dtEndDateTime)}
                                </li> */}
                            </ul>
                            <div className='thumbnail-container bg-transparent object-fit rounded-3'>
                                <div className='thumbnail'>
                                    <Image className="lazy" data-src={ImageWebp} src={ImageWebp} alt={DetailRecord?.varTitle} title={DetailRecord?.varTitle} width="447" height="327"/>
                                </div>
                            </div>
                        </Col>
                        {/* {DetailRecord?.txtDescription ? (<Col md={12} lg={9} className="cms mt-4 mt-md-5" dangerouslySetInnerHTML={{ __html: DetailRecord?.txtDescription }}></Col>) : ''} */}
                        {DetailRecord?.txtDescription ? (
                            <Col md={12} lg={9} className="cms mt-4 mt-md-5" dangerouslySetInnerHTML={{ __html: DetailRecord?.txtDescription }}></Col>
                            ) : (
                            <Col md={12} lg={9} className="cms mt-4 mt-md-5" ><p>{DetailRecord?.varShortDescription}</p></Col>
                        )}
                    </Row>
                </Container>
            </section>

            { OtherEvents?.events && OtherEvents?.events?.length > 0 ? (
                isLoading ? (<> Loading... </>) : (
                    <section className="news-section section-gap pt-4 pt-lg-5 pb-md-0 " data-aos="fade" data-aos-duration="1500">
                        <Container>
                            <Row>
                                <Col xs={12}>
                                    <h2 className="sec-heading text-center mb-4 mb-md-5" data-aos="fade">
                                        <span className="ff-2">
                                            <span className="star">
                                                <i className="blue" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                                <i className="red" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="300"><StarIcon/></i>
                                                <i className="yellow" data-aos="zoom-in" data-aos-duration="1500" data-aos-delay="100"><StarIcon/></i>
                                            </span>
                                            <span data-aos="fade" data-aos-duration="1500" data-aos-delay="500">Related</span>
                                        </span>
                                        <span className="title-line" data-aos="fade" data-aos-duration="1500" data-aos-delay="500">
                                            <span>EVENTS</span>
                                        </span>
                                    </h2>
                                </Col>

                                <Col xs={12}>
                                    <div className="news-section-inner">
                                        <Swiper className="px-1 px-md-2"
                                            spaceBetween={30}
                                            navigation={{
                                                nextEl: ".custom-next",
                                                prevEl: ".custom-prev",
                                            }}
                                            modules={[Navigation]}
                                            breakpoints={{
                                                1366: { slidesPerView: 3 },
                                                992: { slidesPerView: 3 },
                                                575: { slidesPerView: 2 },
                                                460: { slidesPerView: 1.5 },
                                                0: { slidesPerView: 1 },
                                            }}
                                        >
                                            {OtherEvents?.events?.map((item) => {
                                                let DetailUrl = '/'+OtherEvents?.modulealias?.moduleAlias+'/'+item?.alias?.varAlias;
                                                let ListingWebp = '';
                                                if(item?.varWebpImgURL){
                                                    ListingWebp = CDN_URL+'caches/'+Constant?.EVENTCALENDERTHUMB?.split(',')[2].replace('*','x')+'/'+item?.varWebpImgURL;
                                                }else{
                                                    ListingWebp = CDN_URL+'assets/images/'+item?.varImgURL;
                                                }
                                                return (
                                                <SwiperSlide key={item?.id} className="py-4">
                                                    <div className="items d-flex flex-column w-100 shadow">
                                                        <Link to={DetailUrl} className="title flex-grow-1">
                                                            <div className="thumbnail-container object-fit bg-transparent" data-thumb="39.6%">
                                                                <div className="thumbnail">
                                                                    <img
                                                                        src={ListingWebp}
                                                                        alt={item?.varTitle}
                                                                        title={item?.varTitle}
                                                                        width={200}
                                                                        height={120}
                                                                        loading="lazy"
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Link>
                                                        <div className="content d-flex flex-column flex-grow-1">
                                                            <div className="date mb-2">{formatDate(item?.dtDateTime)}</div>
                                                            <h4>
                                                                <Link to={DetailUrl} className="title flex-grow-1" title={item?.varTitle}>
                                                                    {item?.varTitle}
                                                                </Link>
                                                            </h4>
                                                            <div>
                                                                <Link to={DetailUrl} className="btn btn-primary mt-4 mt-md-5" title="READ MORE">
                                                                    READ MORE<BtnArrow />
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            )})}
                                        </Swiper>
                                    </div>
                                </Col>
                                <Col xs={12} className="event-slider text-center mt-4">
                                    <Button title="Previous" className="nav-icon custom-prev">
                                        <i className="left"><BtnArrow /></i>
                                    </Button>
                                    <Button title="Next" className="nav-icon custom-next">
                                        <i className="right"><BtnArrow /></i>
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                    )
                ) : ''
            }
        </>
    )
}

export default EventCalenderDetail;